import type { VideoAssetKey } from "@/lib/video-assets";

export interface BlogPost {
  title: string;
  subtitle: string;
  date: string;
  categories: string[];
  coverImage: string;
  ogImage?: string;
  coverVideoKey?: VideoAssetKey;
}

// Blog post metadata keyed by slug
export const BLOG_POSTS: Record<string, BlogPost> = {
  "collaborative-canvas": {
    title: "The Collaborative Canvas: A New Era of Agentic Interaction",
    subtitle:
      "The artifact panel is now a collaborative workspace, unlocking seamless human-agent interaction on an evolving canvas.",
    date: "May 5, 2026",
    categories: ["Publication"],
    coverImage:
      "/images/blog/collaborative-canvas/hero-collaborative-canvas.png",
    ogImage: "/images/blog/collaborative-canvas/hero-collaborative-canvas.png",
  },
  "agentica-mcp": {
    title: "Agentica MCP: A Stateful REPL for Your Agents",
    subtitle:
      "Use Agentica in your favorite agent harness via the industry-standard MCP protocol.",
    date: "May 5, 2026",
    categories: ["Publication"],
    coverImage: "/images/blog/agentica-mcp/with-agentica-mcp.png",
  },
  "arc-agi-3": {
    title: "From 0% to 36% on Day 1 of ARC-AGI-3",
    subtitle: "Achieving 36% on ARC-AGI-3 using the Agentica framework.",
    date: "March 25, 2026",
    categories: ["Research"],
    coverImage: "/images/blog/meta/arc-agi-3.png",
    ogImage: "/images/blog/meta/arc-agi-3.png",
  },
  "introducing-agentica": {
    title: "Introducing Agentica: Agents by Anyone, for Everyone",
    subtitle: `Agentica Beta is live.\nA builder for long-running AI agents. Describe a task in plain English, connect your tools, and deploy an agent that keeps working in the background.`,
    date: "March 19, 2026",
    categories: ["Publication"],
    coverImage: "/images/blog/meta/2026-03-09-introducing-agentica.png",
    ogImage: "/images/blog/meta/2026-03-09-introducing-agentica.png",
    coverVideoKey: "introducing-agentica/rental-tracker",
  },
  "runtime-as-context": {
    title: "Runtime as Context: How Agentica SDK Agents Reason Over Data",
    subtitle:
      "Introducing a new paradigm for LLMs that leverages runtime context to enhance reasoning and decision-making.",
    date: "February 19, 2026",
    categories: ["Publication"],
    coverImage:
      "/images/blog/runtime-as-context/agentica-deepagents-visualization.png",
  },
  arcgentica: {
    title: "SotA ARC-AGI-2 Results with REPL Agents",
    subtitle:
      "Exploiting the reasoning capabilities of code mode agents and RLMs with the Agentica framework.",
    date: "February 10, 2026",
    categories: ["Research"],
    coverImage: "/images/blog/meta/2025-02-12-arcgentica.png",
  },
  "beyond-code-mode-agentica": {
    title: "Beyond Code Mode: The Agentica SDK",
    subtitle: "Build agents that interact with runtime objects through code.",
    date: "December 9, 2025",
    categories: ["Publication"],
    coverImage: "/images/blog/beyond-code-mode/CHART_DARK_MODE.png",
  },
};

// Display order for the blog index (newest first)
export const ALL_POST_SLUGS = [
  "collaborative-canvas",
  "agentica-mcp",
  "arc-agi-3",
  "introducing-agentica",
  "runtime-as-context",
  "arcgentica",
  "beyond-code-mode-agentica",
] as const;
